
<span class="input readonly"
      [class.placeholder]="value === ''"
      [attr.aria-invalid]="invalid">{{value === '' ? (placeholder === '' ? '&nbsp;' : placeholder) : value}}</span>
